const i18n = {
	startDate: {
		1 : "Дата вступления в должность",
		0 : "Дата ўступлення ў пасаду"
	},
	endDate: {
		1 : "Дата окончания нахождения в должности",
		0 : "Дата заканчэння знаходжання на пасадзе"
	},
	period: {
		1 : "Период работы",
		0 : "Перыяд работы"
	},
	positionName: {
		1 : "Должность",
		0 : "Пасада"
	}
}

export default i18n
